<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
    import { ReferralsRepository } from '../../modules/eventsApi/referrals/referrals.repository'
    import { ReferralsService } from '../../modules/eventsApi/referrals/referrals.service'
    import { Referral } from '../../modules/eventsApi/referrals/referral'
    import type { ReferralCreateDto } from '../../modules/eventsApi/referrals/referral-create.dto'
    import type { ReferralUpdateDto } from '../../modules/eventsApi/referrals/referral-update.dto'
    import ObReferralItem from './ob-referral-item.svelte'
    import ObStep from './ob-step.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    const dispatch = createEventDispatcher()
    let min = 0
    let total = 0
    let methods = []
    let show = false
    let loaded = false
    const rep = new ReferralsRepository()
    const service = new ReferralsService(rep)

    // a lista começa no que já existe: não dá para ter menos origens do que as já cadastradas
    $: totalOptions = Array.from({ length: 15 }, (_, index) => ({ value: index + min, label: String(index + min) }))

    function totalChange() {
        while (methods.length != total) {
            if (methods.length > total) {
                methods.pop()
                continue
            }
            if (methods.length < total) {
                let s = new Referral()
                methods.push(s)
            }
        }
        methods = methods
    }

    function onBack() {
        if (methods.length > 0) {
            if (!confirm('As alterações dessa tela serão perdidas ao voltar. Deseja mesmo voltar?')) return false
        }
        dispatch('back')
    }

    async function onNext() {
        if (show) return
        if (await saveEntity()) {
            dispatch('next')
        }
    }

    onMount(async () => {
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            let result = await service.getAll()
            if (result.length === 0) {
                result.push({
                    label: 'Google',
                })
                result.push({
                    label: 'Instagram',
                })
                result.push({
                    label: 'Facebook',
                })
                result.push({
                    label: 'Programa Indica',
                })
                result.push({
                    label: 'Indicação espontânea',
                })
            }
            min = result.length
            total = result.length
            methods = result
            loaded = true
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function createEntity(entity) {
        try {
            show = true

            const dto: ReferralCreateDto = {
                label: entity.label,
            }
            entity = await service.create(dto)
            return true
        } catch (error) {
            window.error(error)
            return false
        } finally {
            show = false
        }
    }

    async function updateEntity(entity) {
        try {
            show = true
            const dto: ReferralUpdateDto = {
                label: entity.label,
            }
            entity = await service.update(entity.referralId, dto)
            return true
        } catch (error) {
            window.error(error)
            return false
        } finally {
            show = false
        }
    }

    function validateAll() {
        for (let entity of methods) {
            if (!validateFields(entity)) return false
        }
        return true
    }

    async function saveEntity() {
        methods = methods.filter((el) => !!el)
        if (!validateAll()) return false
        for (let entity of methods) {
            if (entity.referralId) {
                if (!(await updateEntity(entity))) return false
            } else {
                if (!(await createEntity(entity))) return false
            }
        }
        return true
    }

    function validateFields(entity) {
        if (!entity.label) {
            window.error('Informe a origem')
            return false
        }
        return true
    }
</script>

<ObStep title="Origens dos Clientes" label="Confirme as possíveis origens de seus novos clientes">
    <svelte:fragment slot="acts">
        <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={onBack} />
        <Zbutton color="primary" icon={faAngleRight} label="Avançar" loading={show} disabled={show} on:click={onNext} />
    </svelte:fragment>

    <ZContainer gapRow="8px" gapCol="8px">
        <Zinput size={4} sizeM={12} label="Quantidade de origens" type="select" options={totalOptions} bind:value={total} on:change={totalChange} />
    </ZContainer>

    {#each methods as referral}
        <ObReferralItem bind:referral />
    {/each}
</ObStep>

<LoadSpinner {show} />
